import React from 'react';
import { formatDateTime } from 'helpers/dateTimeFormatter';
import { RadioButton } from 'sharedComponents/RadioButton';
import { CHART_PLUGINS } from 'sharedComponents/Chart/constants';
import { baseToCustomUOM, getMeasurementUnits, getMeasurementUnitSymbol } from 'helpers/unitHelper';
import { setMaxPrecision } from 'helpers/formatters';

export const TIMESTAMP_TABLE_COLUMN_KEYS = {
    RADIO: 'radio',
    TIMESTAMP: 'timestamp',
    SPEED: 'speed',
    LINE_FREQUENCY: 'lineFrequency',
    SKIN_TEMPERATURE: 'skinTemperature'
};

export const SORT_DIRECTION = {
    ASC: 'asc',
    DESC: 'desc'
};

export const SPEED_LABEL = 'Speed';
export const SPEED_UNIT = 'RPM';

export const TEMPERATURE_UNIT_GROUP_ID = 4;
export const MAX_PRECISION = 2;

export const chartModules = [
    CHART_PLUGINS.NO_DATA_TO_DISPLAY,
    CHART_PLUGINS.HIGHCHARTS_MORE,
    CHART_PLUGINS.BOOST,
    CHART_PLUGINS.STOCK
];

export const PiezoSensor = {
    axisName: 'PiezoFFTJsonData',
    id: 'Piezo'
};

export const AssetTypes = {
    GENERAL_MACHINERY: 'GenericMachine'
};

export const getColumns = (selectedTimestamp, setSelectedTimestamp, trendKPIsList = [], maxPrecision = 2) => {
    // Helper function to get unit from trendKPIsList
    const getUnit = (timeseriesKey) => {
        if (!trendKPIsList || !Array.isArray(trendKPIsList)) {
            return '';
        }
        // Flatten the nested structure and find the matching timeseries
        const allKPIs = trendKPIsList?.flatMap(kpiGroup => {
            if (kpiGroup?.data) {
                return Object.values(kpiGroup?.data);
            }
            return [];
        });
        const kpi = allKPIs.find(k => k?.timeseriesKey === timeseriesKey);
        return kpi?.unit || '';
    };

    const speedUnit = getUnit('Speed');
    const lineFrequencyUnit = getUnit('LineFrequency');

    return [
        {
            width: 50,
            key: 'radio',
            title: '',
            render: (_, { timestamp }) => <RadioButton
                id={timestamp}
                checked={selectedTimestamp === timestamp}
                onClick={() => setSelectedTimestamp(timestamp)}
            />
        },
        {
            title: '',
            dataIndex: 'timestamp',
            key: 'timestamp',
            width: 250,
            render: (timestamp) => formatDateTime(timestamp)
        },
        {
            title: '',
            dataIndex: 'speed',
            key: 'speed',
            width: 200,
            render: (speed) => {
                if (speed !== null && speed !== undefined) {
                    const roundedSpeed = setMaxPrecision(speed, maxPrecision);
                    return `${roundedSpeed} ${speedUnit}`;
                }
                return '-';
            }
        },
        {
            title: '',
            dataIndex: 'lineFrequency',
            key: 'lineFrequency',
            width: 200,
            render: (lineFrequency) => {
                if (lineFrequency !== null && lineFrequency !== undefined) {
                    const roundedLineFrequency = setMaxPrecision(lineFrequency, maxPrecision);
                    return `${roundedLineFrequency} ${lineFrequencyUnit}`;
                }
                return '-';
            }
        },
        {
            title: '',
            dataIndex: 'skinTemperature',
            key: 'skinTemperature',
            width: 200,
            render: (skinTemperature) => {
                if (skinTemperature !== null && skinTemperature !== undefined) {
                    const convertedValue = baseToCustomUOM.convertWithGroups(4, skinTemperature, getMeasurementUnits());
                    const roundedValue = setMaxPrecision(convertedValue, maxPrecision);
                    const unit = getMeasurementUnitSymbol(4) || '°C';
                    return `${roundedValue} ${unit}`;
                }
                return '-';
            }
        },
    ];
};


export const bearingFrequencyTypes = {
    BSF: { name: 'BSF', style: 'Dot' },
    BPFI: { name: 'BPFI', style: 'DashDot' },
    BPFO: { name: 'BPFO', style: 'LongDash' }
};

export const showBearingFaultHarmonics = [
    'Default',
    '10x',
    '100x',
];
